export enum PAYROLL_STATUS {
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  SENT = 'SENT',
  ERROR = 'ERROR',
}

export const PAYROLL_STATUS_LABELS = {
  [PAYROLL_STATUS.IN_PROGRESS]: 'IN PROGRESS',
  [PAYROLL_STATUS.DONE]: 'DONE',
  [PAYROLL_STATUS.SENT]: 'SENT',
  [PAYROLL_STATUS.ERROR]: 'ERROR',
}

export const statusOptions = [
  { id: '', name: 'All Status' },
  {
    id: PAYROLL_STATUS.IN_PROGRESS,
    name: PAYROLL_STATUS_LABELS[PAYROLL_STATUS.IN_PROGRESS],
  },
  { id: PAYROLL_STATUS.DONE, name: PAYROLL_STATUS_LABELS[PAYROLL_STATUS.DONE] },
  { id: PAYROLL_STATUS.SENT, name: PAYROLL_STATUS_LABELS[PAYROLL_STATUS.SENT] },
  {
    id: PAYROLL_STATUS.ERROR,
    name: PAYROLL_STATUS_LABELS[PAYROLL_STATUS.ERROR],
  },
]
